module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/6th/mainvisual-title-sp_7c466ef1dc16b671f82f8395af46a06e.png";